/**
 * created by zhouzt on 2020-05-21
 *
 * description: 后定价接口
 *
 */

const config = require('libs/config.js')

const pricing = {
	// 订单列表
	pricingOrderList: (role, status = '') => config.MS_XY_PATH + `/outline/${role}/order/quote/${status}`,
	// 后定价订单暂存订单
	pricingTempSave: role => config.MS_XY_PATH + `/outline/${role}/order/quote/saveAsTemp`,
	// 后定价订单保存订单
	pricingSave: role => config.MS_XY_PATH + `/outline/${role}/order/quote/save`,
	// 后定价订单修改订单
	pricingModify: (role, pkid) => config.MS_XY_PATH + `/outline/${role}/order/quote/${pkid}`,
	// 后定价订单修改订单
	pricingDel: (role, pkid) => config.MS_XY_PATH + `/outline/${role}/order/quote/${pkid}`,
	// 后定价发送订单
	pricingSend: role => config.MS_XY_PATH + `/outline/${role}/order/quote/send`,
	// 后定价确认报价
	pricingConfirmQuote: role => config.MS_XY_PATH + `/outline/${role}/order/quote/confirmQuote`,
	// 后定价驳回报价
	pricingRejectQuote: role => config.MS_XY_PATH + `/outline/${role}/order/quote/rejectQuote`,
	// 后定价提醒对方报价(没有 quote )
	pricingRemindQuote: (role, orderCode) => config.MS_XY_PATH + `/outline/${role}/order/remindQuote/${orderCode}`,
	// 后定价撤回订单
	pricingRecall: config.MS_XY_PATH + '/outline/buy/order/quote/recall',
	// 后定价作废订单
	pricingCancel: config.MS_XY_PATH + '/outline/buy/order/quote/cancel',
	// 后定价拒绝订单
	pricingRefuse: config.MS_XY_PATH + '/outline/sell/order/quote/refuse',
	// 后定价提醒对方确认
	pricingRemindCofirm: (role, orderCode) => config.MS_XY_PATH + ``,
	// 后定价订单报价
	pricingQuote: role => config.MS_XY_PATH + `/outline/${role}/order/after/quote`,
	// 后定价订单暂存报价
	pricingTempQuote: config.MS_XY_PATH + '/outline/sell/order/after/quote/stage',
	// 后定价订单撤回报价
	pricingRecallQuote: config.MS_XY_PATH + '/outline/sell/order/after/quote/recall'
}

export default pricing



// WEBPACK FOOTER //
// ./src/api/trade/pricing.js